import React from 'react';
import { Link } from 'react-router-dom';
import picofme from '../../assests/picofme.jpg';
import ContactIcons from '../Contact/ContactIcons';

const SideBar = () => (
  <section id="sidebar">
    <section id="intro">
      <Link to="/" className="logo">
        <img src={picofme} alt="" />
      </Link>
      <header>
        <h2>George Vytka</h2>
        <p>
          <a href="mailto:george.vytka@gmail.com">george.vytka@gmail.com</a>
        </p>
      </header>
    </section>

    <section className="blurb">
      <h2>About</h2>
      <p>
        Hi, I&apos;m George. I am a Hi, I&apos;m George . I&apos;m an IT
        professional with a background in computer science and a strong interest
        in technology, systems, and problem-solving. I&apos;m passionate about
        helping organizations run smoothly by managing infrastructure,
        supporting users, and improving workflows.
      </p>
      <ul className="actions">
        <li>
          {!window.location.pathname.includes('/resume') ? (
            <Link to="/resume" className="button">
              Learn More
            </Link>
          ) : (
            <Link to="/about" className="button">
              About Me
            </Link>
          )}
        </li>
      </ul>
    </section>

    <section id="footer">
      <ContactIcons />
      <p className="copyright">.</p>
    </section>
  </section>
);

export default SideBar;
